import React from "react";

import { FormFieldReset } from "~/components/form/reset";

import { Widget, WidgetBody, WidgetHeader } from "../../../_widget";
import { LegendSection } from "../_legend/section";
import { ResetToDefaultSection } from "../_reset-to-default-section";
import { ThresholdsSection } from "../_thresholds/section";
import { YAxisLabelsSection } from "../_y-axis/labels-section";
import { YAxisRangeSection } from "../_y-axis/range-section";

import { FormState } from "./form-state";

export interface BarChartSettingsProps {
	settings: FormState;
}

export const BarChartSettings: React.FC<BarChartSettingsProps> = ({ settings }) => (
	<div className="grid h-full grid-cols-3 gap-4">
		<div className="flex flex-col gap-4">
			<LegendSection legend={settings.fields.legend} />
		</div>

		<div className="flex flex-col gap-4">
			<YAxisLabelsSection yAxis={settings.fields.yAxis} />

			<YAxisRangeSection range={settings.fields.range} />
		</div>

		<div className="flex flex-col gap-4">
			<Widget>
				<WidgetHeader className="uppercase" title="Thresholds">
					<FormFieldReset className="ml-auto" state={settings.fields.thresholds} />
				</WidgetHeader>

				<WidgetBody card>
					<ThresholdsSection
						mode={settings.fields.thresholds.fields.mode}
						thresholds={settings.fields.thresholds.fields.steps}
					/>
				</WidgetBody>
			</Widget>

			<ResetToDefaultSection onClick={() => FormState.resetToDefault(settings)} />
		</div>
	</div>
);
